import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import XHR from "i18next-xhr-backend";
import languageEN from "./i18n/en/translate.json";
import languageGU from "./i18n/gu/translate.json";

const userRole = localStorage.getItem("userRole");

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: languageEN,
      gu: languageGU,
    },
    /* default language when load the website in browser */
    // lng: 'en',
    // lng: window.localStorage.getItem('languageSet'),
    lng:
      userRole === "state"
        ? window.localStorage.getItem("stateLanguage")
        : userRole === "mis"
        ? window.localStorage.getItem("misLanguage")
        : userRole === "drc"
        ? window.localStorage.getItem("drcLanguage")
        : userRole === "brc"
        ? window.localStorage.getItem("brcLanguage")
        : userRole === "crc"
        ? window.localStorage.getItem("crcLanguage")
        : userRole === "school"
        ? window.localStorage.getItem("schoolLanguage")
        : "en",
    reloadOnLanguageChange: false,
    /* When react i18next not finding any language to as default in borwser */
    fallbackLng: "en",
    /* debugger For Development environment */
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    detection: {
      // order: ["navigator"],
      // caches: [],
      order: ['querystring', 'cookie', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['sessionStorage', 'cookie'],
    },
    react: {
      wait: true,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed",
      nsMode: "default",
    },
  });

export default i18n;
